export function TermsOfService() {
  return (
    <div className="text-base max-w-7xl mx-auto px-6 my-4 md:px-10 lg:px-6 text-[#333333]">
      <div className="text-lg">
        <h4 className="font-semibold underline">
          Last Minute Wellness Inc. User Terms of Service
        </h4>
        <p>
          By clicking the box to accept these terms or by using or placing an
          order using Last Minute Wellness Inc.’s application or website, you
          confirm that you accept these terms and conditions and agree that they
          will apply to your use of the technology and services described
          therein. Please read these terms carefully before accessing or using
          the services.
        </p>
        <p>Last Minute Wellness Inc. – Terms of Service</p>
        <p>Last revised: 29-09-2025</p>
      </div>

      <div className="space-y-4 mt-4">
        <div>
          <h1 className="font-semibold">1. CONTRACTUAL RELATIONSHIP</h1>
          <p>
            Last Minute Wellness Inc. – Terms of Service (“<strong>Last Minute Wellness
            Terms</strong>”) govern the access or use by you from any location of any
            platform, applications, websites, content, products, and services
            (the “<strong>Services</strong>”) made available by Last Minute Wellness Inc. (“<strong>Last
            Minute Wellness</strong>”).
          </p>
          <p className="my-1">
            PLEASE READ THESE TERMS CAREFULLY BEFORE ACCESSING OR USING THE
            SERVICES.
          </p>
          <p>
            You may accept these terms by clicking a box or by using or placing
            an order using the Last Minute Wellness-branded application or
            website or by otherwise affirmatively indicating your acceptance and
            subsequently, by continuing to access and use the Services, you
            agree to be bound by these Last Minute Wellness Terms, as may be
            amended from time to time, which establishes a contractual
            relationship between you and Last Minute Wellness. If you do not
            agree to these Last Minute Wellness Terms, at any time, you should
            not access or use the Services. These Last Minute Wellness Terms
            expressly supersede prior agreements or arrangements with you and
            Last Minute Wellness and/or any affiliates of Last Minute Wellness
            regarding the provision of Services. Last Minute Wellness may
            immediately terminate the Services with respect to you, or generally
            cease offering or deny access to the Services or any portion
            thereof, at any time for any reason.
          </p>
          <p>
            Supplemental terms may apply to certain Services, such as policies
            for a particular event, activity or promotion, or a particular
            category of Services. Supplemental terms will be provided to you in
            connection with the applicable Services. You agree to abide by the
            Last Minute Wellness, the Last Minute Wellness Website Terms and
            Conditions (<strong>“Website Terms”</strong>) and the Last Minute
            Wellness Privacy Policy (<strong>“Privacy Policy”</strong>) and any
            other policies that Last Minute Wellness may establish from time to
            time.
          </p>
          <p>
            Any supplemental terms and policies, including the Website Terms,
            Privacy Policy, and Waiver and Consent are in addition to, and shall
            be deemed a part of, the Last Minute Wellness Terms for the purposes
            of the applicable Services. Supplemental terms shall prevail over
            these Last Minute Wellness Terms in the event of a conflict with
            respect to the applicable Services.{" "}
          </p>
          <h5 className="font-semibold mt-2">Amendments</h5>
          <p>
            Last Minute Wellness may amend the Last Minute Wellness Terms, any
            supplemental terms or policies (including the Website Terms or
            Privacy Policy) related to the Services from time to time. Last
            Minute Wellness will provide you with notice in the event of a
            material change to any Last Minute Wellness Terms, policies or
            supplemental terms that detrimentally affect your rights under these
            Last Minute Wellness Terms, by sending an email, providing notice
            through the Services or updating the date at the top of these Last
            Minute Wellness Terms. Unless Last Minute Wellness indicates
            otherwise in its notice (if applicable), the amendments will be
            effective immediately upon posting of such updated Last Minute
            Wellness Terms at its website. Your continued access or use of the
            Services after Last Minute Wellness provides such notice, if
            applicable, or after Last Minute Wellness posts such updated terms,
            constitutes your acceptance of the changes and consent to be bound
            by the Last Minute Wellness Terms, policies and supplemental terms,
            as amended. If you do not agree to the amended Last Minute Wellness
            Terms, policies or supplemental terms, you must stop accessing and
            using the Services.
          </p>
          <h5 className="font-semibold mt-2">Privacy</h5>
          <p>
            Our collection and use of personal information in connection with
            the Services is as provided in Last Minute Wellness’s Privacy
            Policy. You consent to Last Minute Wellness potentially providing to
            an insurance claims processor or an insurer any necessary
            information (including your contact information) if there is a
            complaint, dispute or conflict associated with your use of the
            Services.
          </p>
        </div>

        <div>
          <h1 className="font-semibold">2. THE SERVICES</h1>
          <p>
            Last Minute Wellness will provide the Services to you in accordance
            with these Last Minute Wellness Terms. The Services constitute the
            provision of a technology platform that enables you, as a user of
            Last Minute Wellness’s applications or websites (each, an{" "}
            <strong>“Application”</strong>) to: (a) arrange and schedule certain
            services with independent third party providers of those services
            that have an agreement with Last Minute Wellness or its affiliates (
            <strong>“Third Party Providers”</strong>), including, without
            limitation: (i) in-home or in-facility health care practitioner;
            (ii) at a health care practitioner clinic or home; and (iii)
            Physiotherapy, Massage Therapy, Acupunture, Chiropractic Care; (b)
            facilitate payments to Third Party Providers for the goods and
            services provided to you by those Third Party Providers and receive
            receipts from a Last Minute Wellness affiliate for those payments;
            and (c) provide related content or services including customer
            support.
          </p>
          <p>
            The Services are made available solely for your personal use. You
            acknowledge that: (a) Last Minute Wellness does not provide any of
            the Services provided by the Third Party Providers; and (b) all such
            Services are provided by Third Party Providers, which are
            independent third-party contractors who are not employed by Last
            Minute Wellness or any of its affiliates. For clarity, Third Party
            Providers are solely responsible for the services they provide to
            you.
          </p>
          <h5 className="font-semibold mt-2">License</h5>
          <p>
            Subject to your compliance with these Last Minute Wellness Terms,
            Last Minute Wellness grants you a limited, non-exclusive,
            non-sublicensable, revocable, non-transferable license to: (i)
            access and use the Applications on your personal device solely in
            connection with your use of the Services; and (ii) access and use
            any content, information and related materials that may be made
            available through the Services, in each case solely for your
            personal use. Any rights not expressly granted herein are reserved
            by Last Minute Wellness and Last Minute Wellness’s licensors.
          </p>
          <h5 className="font-semibold mt-2">Restrictions</h5>
          <p>
            You may not: (i) remove any copyright, trade mark or other
            proprietary notices from any portion of the Services; (ii)
            reproduce, modify, prepare derivative works based upon, distribute,
            license, lease, sell, resell, transfer, publicly display, publicly
            perform, transmit, stream, broadcast or otherwise exploit the
            Services except as expressly permitted by Last Minute Wellness;
            (iii) decompile, reverse engineer or disassemble the Services except
            as may be permitted by applicable law; (iv) link to, mirror or frame
            any portion of the Services; (v) cause or launch any programs or
            scripts for the purpose of scraping, indexing, surveying, or
            otherwise data mining any portion of the Services or unduly
            burdening or hindering the operation and/or functionality of any
            aspect of the Services; or (vi) attempt to gain unauthorised access
            to or impair any aspect of the Services or its related systems or
            networks.
          </p>
          <p className="font-semibold">Provision of the Services</p>
          <p>
            You acknowledge that portions of the Services may be made available
            under Last Minute Wellness’s various brands, related trade names and
            trademarks. You also acknowledge that the Services may be made
            available under such brands by or in connection with: (i) certain of
            Last Minute Wellness’s affiliates; or (ii) Third Party Providers.
          </p>
          <h5 className="font-semibold mt-2">Third Party Services and Content</h5>
          <p>
            The Services may be made available or accessed in connection with
            third-party services and content (including Applications hosted by
            the third parties) that Last Minute Wellness does not control. You
            acknowledge that different terms of use and privacy policies may
            apply to your use of such third party services and content. Last
            Minute Wellness does not endorse such third party services and
            content and in no event shall Last Minute Wellness be responsible or
            liable for any products or services of such third party providers.
          </p>
          <h5 className="font-semibold mt-2">Ownership</h5>
          <p>
            The Services and all rights therein are and shall remain Last Minute
            Wellness’s property or the property of Last Minute Wellness’s
            licensors. Neither these Last Minute Wellness Terms nor your use of
            the Services convey or grant to you any rights: (i) in or related to
            the Services except for the limited license granted above; or (ii)
            to use or reference in any manner Last Minute Wellness’s company
            names, logos, product and service names, trademarks or services
            marks or those of Last Minute Wellness’s licensors, except with the
            prior written consent of Last Minute Wellness, in its sole and
            unfettered discretion.
          </p>
          <h5 className="font-semibold mt-2">Last Minute Wellness Service Area</h5>
          <p>
            The goods and services that you may request using the Services are
            available in designated areas as communicated via the Application
            from time to time (
            <strong>“Last Minute Wellness Service Area”</strong>). Last Minute
            Wellness does not guarantee that you will be able to use the
            Services to request any such goods and services in the Last Minute
            Wellness Service Area at all times, or in any areas outside of the
            Last Minute Wellness Service Area.
          </p>
          <h5 className="font-semibold mt-2">Due Diligence and Service Provider Verification</h5>
          <p>
            Last Minute Wellness’s verification of Third Party Providers is
            limited to confirming that: (i) the Third Party Provider’s identity
            has been verified through government-issued identification; (ii) the
            Third Party Provider maintains an active business license or is
            otherwise legally permitted to provide services in their
            jurisdiction; (iii) the Third Party Provider has provided background
            checks and police clearance certificates; and (iv) the Third Party
            Provider has provided evidence of carrying commercial general
            liability insurance and auto insurance. Last Minute Wellness does
            not verify the scope, coverage limits, exclusions, or ongoing
            validity of such insurance, nor does Last Minute Wellness guarantee
            the qualifications, workmanship, or suitability of any Third Party
            Provider and does not conduct ongoing verification or background
            checks. You acknowledge that it is your responsibility to make your
            own inquiries and assessments before engaging or relying on any
            Third Party Provider.
          </p>
        </div>
        <div>
          <h1 className="font-semibold mt-2">3. YOUR USE OF THE SERVICES</h1>
          <h5 className="font-semibold mt-2">User Accounts</h5>
          <p>
            In order to use most aspects of the Services, you must register for
            and maintain an active personal user Services account (
            <strong>“Account”</strong>). You must be at least 18 years of age,
            or the age of legal majority in your jurisdiction (if different than
            18), to obtain an Account. Account registration requires you to
            submit to Last Minute Wellness certain personal information, such as
            your name, address, government issued identification, and phone
            numbers, as well as at least one valid payment method (either a
            credit card or accepted payment partner). If you assign other third
            parties to access your Account on your behalf and to order Services
            on your Account, those third parties must also set up Accounts,
            provide similar personal information, but they may be assigned as
            delegates (<strong>“Delegates”</strong>) to your Account. You and
            each Delegate agree to maintain accurate, complete, and up-to-date
            information in your and their respective Accounts. Your failure to
            maintain accurate, complete, and up-to-date Account information,
            including having an invalid or expired payment method on file, may
            result in your inability to access or use the Services. You are
            responsible for all activity that occurs under your Account, even if
            performed by a Delegate on your behalf, and you agree to maintain
            the security and secrecy of your Account username and password at
            all times. Unless otherwise permitted by Last Minute Wellness in
            writing, you may only possess one Account, provided that you may
            authorize a Delegate to have access to your Account.
          </p>
          <h5 className="font-semibold mt-2">User Requirements and Conduct</h5>
          <h5 className="font-semibold">General</h5>
          <p>
            The Services are not available for use by persons under the age of
            18. You may not assign or otherwise transfer your Account to any
            other person or entity, except where you authorize a Delegate to
            have access to your Account. You agree to comply with all applicable
            laws when accessing or using the Services, and you may only access
            or use the Services for lawful purposes and in accordance with these
            Last Minute Wellness Terms. You will not, in your use of the
            Services, cause nuisance, harassment, annoyance, inconvenience,
            personal injury, or property damage, whether to the Third Party
            Provider or any other party, including Last Minute Wellness, its
            affiliates or any of their employees, agents or contractors. In
            certain instances, you may be asked to provide proof of identity or
            other method of identity verification to access or use the Services,
            and you agree that you may be denied access to or use of the
            Services if you refuse to provide proof of identity or other method
            of identity verification. A Third Party Provider may also require
            you to agree to additional terms and conditions governing their
            provision of services to you.
          </p>
          <h5 className="font-semibold mt-2">
            Premises Safety Requirements and Service Provider Refusal Rights
          </h5>
          <p>
            Certain Services may require Third Party Provider to come to your
            home or another location of your choosing. You are solely
            responsible for ensuring that the premises where Services are to be
            performed for you are safe, sanitary, and secure. This includes,
            without limitation, providing adequate lighting, clear access
            pathways, and a hazard-free working environment. If a Third Party
            Provider determines, in their reasonable discretion, that the
            premises are unsafe or unfit for the provision of Services, the
            Third Party Provider may decline to provide or may suspend the
            provision of Services. In such circumstances, you agree that any
            prepaid sums will be forfeited and no refund will be provided.
            Repeated occurrences may result in the suspension or termination of
            your Account.
          </p>
          <h5 className="font-semibold mt-2">Pets</h5>
          <p>
            For the safety of a Third Party Provider, you are responsible for
            properly securing any animals under your care and control (whether
            or not they are actually owned by you) located on your premises
            where the Services are rendered with a leash, harness, crate /
            carrier, containment in a separate closed room, or through other
            means. You are also responsible for any damage that the animal
            causes to the Third Party Provider or to their property. You may be
            subject to a Damages Fee (as defined below) for any property damage,
            personal injury or other claim, loss, liability or damage caused by
            an animal that is under your care and control (whether or not they
            are actually owned by you) located on your premises where the
            Services are rendered.
          </p>
          <h5 className="font-semibold mt-2">Mobility Assistance</h5>
          <p>
            If you request <strong>“Mobility Assistance”</strong> to facilitate
            any part of the Services where Third Party Provider agrees to
            provide you with assistance prior, during or after the provision of
            the Services, you acknowledge and agree that neither Last Minute
            Wellness nor the Third Party Provider is responsible for any injury
            or incident that may arise out of the Mobility Assistance provided
            by the Third Party Provider.
          </p>
          <h5 className="font-semibold mt-2">Commercial Electronic Messaging</h5>
          <p>
            By creating an Account, you agree that Last Minute Wellness or its
            affiliates may send you commercial electronic messages (including
            email, SMS or push notifications, where applicable) as part of the
            normal business operation of your use of the Services and to send
            you marketing and promotional messages about any of Last Minute
            Wellness’s Applications, products or services. Where it may be
            impracticable (including for push notifications) to include an
            unsubscribe mechanism in certain commercial electronic messages, you
            may opt-out of receiving commercial electronic messages from Last
            Minute Wellness at any time. You also acknowledge that opting out of
            receiving electronic messages may impact your use of the Services.
          </p>
          <h5 className="font-semibold mt-2">Promotional Codes</h5>
          <p>
            A Last Minute Wellness affiliate may, in its sole discretion, create
            promotional codes that may be redeemed for Account credit, or other
            features or benefits related to a Third Party Provider’s Services,
            subject to any additional terms that the Last Minute Wellness
            affiliate establishes on a per promotional code basis (
            <strong>“Promo Codes”</strong>). You agree that Promo Codes: (i)
            must be used for the intended audience and purpose, and in a lawful
            manner; (ii) may not be duplicated, sold or transferred in any
            manner, or made available to the general public (whether posted to a
            public form or otherwise), unless expressly permitted by the Last
            Minute Wellness affiliate; (iii) may, as permitted by law, be
            disabled by Last Minute Wellness or its affiliate at any time
            without liability to Last Minute Wellness or its affiliate; (iv) may
            only be used pursuant to the specific terms that the Last Minute
            Wellness affiliate establishes for such Promo Code; (v) are not
            valid for cash; and (vi) may expire prior to your use. Last Minute
            Wellness reserves the right to withhold or deduct credits or other
            features or benefits obtained through the use of Promo Codes by you
            or any other user in the event that the Last Minute Wellness
            reasonably determines or believes that the use or redemption of the
            Promo Code was in error, fraudulent, illegal, or in violation of the
            applicable Promo Code terms or these Last Minute Wellness Terms.
          </p>
          <h5 className="font-semibold mt-2">User Provided Content</h5>
          <p>
            Last Minute Wellness may, in Last Minute Wellness’s sole discretion,
            permit you from time to time to submit, upload, publish or otherwise
            make available to Last Minute Wellness through the Services textual,
            audio, and/or visual content and information, including ratings,
            photographs, commentary and feedback related to the Services,
            initiation of support requests, and submission of entries for
            competitions and promotions (<strong>“User Content”</strong>). Any
            User Content provided by you remains your property. However, by
            providing User Content to Last Minute Wellness, you grant Last
            Minute Wellness and its affiliates a worldwide, perpetual,
            irrevocable, transferable, license for no fee, with the right to
            sublicense, to use, copy, modify, create derivative works of,
            distribute, publicly display, publicly perform, and otherwise
            exploit in any manner such User Content in all formats and
            distribution channels now known or hereafter devised (including in
            connection with the Services and Last Minute Wellness’s business and
            on third-party sites and services), without further notice to or
            consent from you, and without the requirement of payment to you or
            any other person or entity.
          </p>
          <p className="my-2">
            You represent and warrant that: (i) you either are the sole and
            exclusive owner of all User Content or you have all rights,
            licenses, consents and releases necessary to grant Last Minute
            Wellness and its affiliates the license to the User Content as set
            forth above; and (ii) neither the User Content nor your submission,
            uploading, publishing or otherwise making available of such User
            Content nor Last Minute Wellness’s or its affiliates’ use of the
            User Content as permitted herein will infringe, misappropriate or
            violate a third party’s intellectual property or proprietary rights,
            or rights of publicity or privacy, or result in the violation of any
            applicable law or regulation.
          </p>
          <p>
            You agree not to provide User Content that is defamatory, libelous,
            hateful, violent, obscene, pornographic, unlawful, or otherwise
            offensive, as determined by Last Minute Wellness in its sole
            discretion, whether or not such material may be protected by law.
            Last Minute Wellness may, but is not obligated to, review, monitor,
            or remove User Content, at Last Minute Wellness’s sole discretion
            and at any time and for any reason, without notice to you.
          </p>
          <h5 className="font-semibold mt-2">Network Access and Devices</h5>
          <p>
            You are responsible for obtaining the data network access necessary
            to use the Services. Your mobile network’s data and messaging rates
            and fees may apply if you access or use the Services from a
            wireless-enabled device and you shall be responsible for such rates
            and fees. You are responsible for acquiring and updating compatible
            hardware or devices necessary to access and use the Services and
            Applications and any updates thereto. Last Minute Wellness does not
            guarantee that the Services, or any portion thereof, will function
            on any particular hardware or devices. In addition, the Services may
            be subject to malfunctions and delays inherent in the use of the
            Internet and electronic communications.
          </p>
        </div>

        <div>
          <h1 className="font-semibold">4. PAYMENT</h1>
          <p>Pre-Authorized Payment and Valid Payment Method Requirement</p>
          <p>
            You agree to maintain a valid, unexpired credit card or other
            accepted payment method on file with your Account at all times. By
            using the Services, you authorize Last Minute Wellness and its
            affiliates to pre-authorize and charge your payment method for all
            amounts payable in connection with the Services, including all
            applicable Third Party Charges, cancellation fees, rescheduling
            fees, Damages Fees, and any other amounts owed under these Terms.
            You acknowledge and agree that Services must be prepaid in full at
            the time of booking and that Last Minute Wellness is authorized to
            charge your payment method without further notice for all such
            amounts.
          </p>
          <p>
            You understand that use of the Services will result in charges to
            you for the services or goods you receive from a Third Party
            Provider (<strong>“Third Party Charges”</strong>). Payment of the
            Third Party Charges shall be considered the same as payment made
            directly by you to the Third Party Provider. Applicable taxes will
            be added to Third Party Charges where required by law. Third Party
            Charges paid by you are final and non-refundable, unless otherwise
            determined by Last Minute Wellness or as set forth in these Last
            Minute Wellness Terms.{" "}
          </p>
          <p>
            All Third Party Charges are due immediately upon booking a service
            appointment and payment will be facilitated by Last Minute Wellness
            or a Last Minute Wellness affiliate using the preferred payment
            method designated in your Account, after which you will be sent a
            receipt. If your primary Account payment method is determined to be
            expired, invalid or otherwise not able to be charged, you agree that
            Last Minute Wellness or a Last Minute Wellness affiliate may, on
            behalf of Third Party Provider, use a secondary payment method in
            your Account, if available.
          </p>
          <p>
            You acknowledge that Last Minute Wellness or a Last Minute Wellness
            affiliate may establish or adjust Third Party Charges for any or all
            services or goods obtained through the use of the Services at any
            time at the direction of the Third Party Provider or otherwise in
            Last Minute Wellness or the Last Minute Wellness affiliate’s
            discretion, including in certain circumstances such as where you
            choose an additional service that incurs an additional charge. Last
            Minute Wellness will use reasonable efforts to ensure that it or the
            Last Minute Wellness affiliate informs you of Third Party Charges
            that may apply, provided that you will be responsible for Third
            Party Charges incurred under your Account. You acknowledge that the
            fact that a payment card statement may reflect a charge from Last
            Minute Wellness or a Last Minute Wellness affiliate, does not
            necessarily mean that Last Minute Wellness or the Last Minute
            Wellness affiliate sold an item or service, but rather that Last
            Minute Wellness or the Last Minute Wellness Affiliate facilitated
            payment processing, and that the merchant stated on your receipt is
            the actual seller.
          </p>
          <h5 className="font-semibold mt-2">Payment Processing</h5>
          <p>
            All payments for Services booked through Last Minute Wellness are
            processed by a third-party payment <strong>“Processor”</strong>. By
            using the Services, you agree to be bound by the Processor’s Terms
            of Service and Privacy Policy, as they may be amended from time to
            time. You authorize Last Minute Wellness to share with the Processor
            any information and payment instructions you provide to us to the
            extent required to complete payment transactions in accordance with
            these Last Minute Wellness Terms, including personal, payment, and
            transactional information.
          </p>
          <h5 className="font-semibold mt-2">Client Insurance Coverage</h5>
          <p>
            You are responsible for confirming with your insurance provider whether a Service or Practitioner is covered under your insurance benefits. Last Minute Wellness will provide a receipt to facilitate your claims with their insurance provider however, you are encouraged to verify coverage details prior to booking Services to avoid any unexpected expenses.
          </p>
        </div>

        <div className="space-y-4">
          <div>
            <h1 className="font-semibold text-3xl">
              Prepayment and Recurring Services
            </h1>
            <h5 className="font-semibold mt-4">Promotional Codes</h5>
            <p>
              You acknowledge that Last Minute Wellness or a Last Minute
              Wellness affiliate may from time to time provide certain users
              with Promo Codes that may result in different amounts charged for
              the same or similar services or goods obtained through the use of
              the Services, and you agree that such Promo Codes are provided to
              you for no fee, have no monetary value, cannot be redeemed for
              cash, are not exchangeable or transferable and, unless also made
              available to you, shall have no bearing on your use of the
              Services or the Third Party Charges applied to you.
            </p>
            <h5 className="font-semibold mt-2">Gratuities</h5>
            <p>
              This payment structure is intended to compensate the Third Party
              Provider for the services or goods provided. You understand and
              agree that, while you are free to provide additional payment as a
              gratuity to any Third Party Provider who provides you with
              services or goods obtained through the Services, you are under no
              obligation to do so. Gratuities are voluntary. After you have
              received services or goods obtained through the Services, you will
              have the opportunity to rate your experience and leave additional
              feedback about your Third Party Provider.
            </p>
            <h5 className="font-semibold mt-2">Cancellations and Refunds</h5>
            <p>
              You may elect to cancel your request for Services from a Third
              Party Provider at any time. If you cancel your request for
              Services greater than forty-eight (48) hours before your scheduled
              appointment you will receive a full refund of all prepaid amounts.
              If you cancel your request for Services less than forty-eight (48)
              hours but before twenty-four (24) hours prior to such Third Party
              Provider’s scheduled booking you will forfeit 50% of your prepaid
              sums. If you cancel a booking with less than twenty-four (24)
              hours' notice, you agree that you will forfeit 100% of your
              prepaid sums. There will be no refunds for missed scheduled
              bookings.
            </p>
            <p className="my-2">
              If any Services provided by a Third Party Provider fail or are
              cancelled for reasons that Last Minute Wellness determines, acting
              reasonably, are attributed to you (for example, without
              limitation, you provided an incorrect address or you were unable
              to provide access to the premises to the Third Party Provider, you
              were unable to provide a safe working environment, or you
              cancelled for any reason, including in respect of any emergency
              affecting you), you will be charged a fee no more than the full
              price for Services ordered from the Third Party Provider. If the
              Services are cancelled for any reason by the Third Party Provider
              other than where Last Minute Wellness determines, acting
              reasonably, that such reason is attributed to you, you will
              receive a full refund of your prepaid sums for the booking.
            </p>
            <p className="my-2">If any Services are cancelled by the Third Party Provider, for any reason other than the reason that is attributed to you, you shall receive a full refund for prepaid sums and an opportunity to reschedule the Services.  </p>
            <p>
              If you require a correction to be made to any Third Party Charge
              you incurred, you must notify Last Minute Wellness in writing
              within 10 days after the Third Party Charge was invoiced after
              which Last Minute Wellness will have no further responsibility and
              you waive your right to later dispute the amounts charged.
            </p>
            <h5 className="font-semibold mt-2">Damages Fees</h5>
            <p>
              Last Minute Wellness may charge you a fee if, during your use of
              the Services, you have caused property damage, personal injury or
              caused any other loss, claim, liability or damage to the Third
              Party Provider or to their personal property (
              <strong>“Claim“</strong>, and the fees associated with the Claim
              is the “Damages Fee”). The amount of such Damages Fee shall be
              determined, in Last Minute Wellness’s sole discretion, based on
              the type of damage and the severity. Last Minute Wellness reserves
              the right to verify or otherwise require documentation of damages
              prior to processing a Damages Fee. In the event that a Third Party
              Provider reports a Claim, and such Claim is verified by Last
              Minute Wellness in its reasonable discretion, Last Minute Wellness
              reserves the right to facilitate payment for the reasonable cost
              of such Damages Fee associated with the Claim on behalf of the
              Third Party Provider using your payment method designated in your
              Account. Such amounts will be transferred by Last Minute Wellness
              to the applicable Third Party Provider and are non-refundable.
            </p>
            <p>
              Additionally, if you fail to comply with these Last Minute
              Wellness Terms you may be responsible for additional fees or
              charges, including without limitation, for transactions that could
              not be completed properly, arising out of or in connection with
              your failure to comply with these Last Minute Wellness Terms.
            </p>
          </div>

          <div>
            <h1 className="font-semibold">
              5. DISCLAIMERS; LIMITATION OF LIABILITY; INDEMNITY
            </h1>
            <p className="mt-4 font-semibold">APPLICATION TO LAST MINUTE WELLNESS AND ITS AFFILIATES</p>
            <p>
              The limitations and disclaimer in this Section apply to the
              liability of Last Minute Wellness and its affiliates under these
              Last Minute Wellness Terms, including in relation to any of the
              Services. The limitations and disclaimer in this Section do not
              purport to limit liability or alter your rights as a consumer
              under applicable law.
            </p>
            <h5 className="font-semibold mt-2">DISCLAIMER</h5>
            <p>
              THE SERVICES ARE PROVIDED “AS IS” AND “AS AVAILABLE”. LAST MINUTE
              WELLNESS AND ITS AFFILIATES DISCLAIM ALL REPRESENTATIONS AND
              WARRANTIES, EXPRESS, IMPLIED OR STATUTORY, NOT EXPRESSLY SET OUT
              IN THESE LAST MINUTE WELLNESS TERMS (INCLUDING ANY SUPPLEMENTAL
              TERMS, WHERE APPLICABLE), INCLUDING ANY IMPLIED WARRANTIES OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
              NON-INFRINGEMENT, AND MAKE NO REPRESENTATION, WARRANTY, OR
              GUARANTEE REGARDING THE RELIABILITY, TIMELINESS, QUALITY,
              SUITABILITY OR AVAILABILITY OF THE SERVICES OR ANY SERVICES OR
              GOODS REQUESTED BY YOU THROUGH THE USE OF THE SERVICES, OR THAT
              THE SERVICES WILL BE FREE OF DEFECTS OR SUITABLE FOR ANY PURPOSE.
              LAST MINUTE WELLNESS AND ITS AFFILIATES DO NOT GUARANTEE THE
              QUALITY, SUITABILITY, SAFETY OR ABILITY OF THIRD PARTY PROVIDERS.
              YOU AGREE THAT THE ENTIRE RISK ARISING OUT OF YOUR USE OF THE
              SERVICES, AND ANY SERVICES OR GOODS REQUESTED BY YOU THROUGH THE
              USE OF THE SERVICES, REMAINS SOLELY WITH YOU, TO THE MAXIMUM
              EXTENT PERMITTED UNDER APPLICABLE LAW. LAST MINUTE WELLNESS DOES
              NOT CONTROL, MANAGE OR DIRECT ANY THIRD PARTY PROVIDERS. THIRD
              PARTY PROVIDERS ARE NOT ACTUAL AGENTS, APPARENT AGENTS, OSTENSIBLE
              AGENTS, OR EMPLOYEES OF LAST MINUTE WELLNESS. LAST MINUTE WELLNESS
              DOES NOT CONTROL, ENDORSE OR TAKE RESPONSIBILITY FOR ANY USER
              CONTENT OR THIRD PARTY CONTENT AVAILABLE ON OR LINKED TO BY THE
              SERVICES. LAST MINUTE WELLNESS CANNOT AND DOES NOT REPRESENT OR
              WARRANT THAT THE SERVICES OR SERVERS ARE FREE OF VIRUSES OR OTHER
              HARMFUL COMPONENTS.
            </p>
            <p>
              Furthermore, Last Minute Wellness makes no representations or
              warranties about the Application or Services’ uptime,
              availability, or permissibility in any particular geographical
              location. From time to time, Last Minute Wellness may conduct
              scheduled or emergency system maintenance, during which time the
              Application may be inaccessible and unavailable, with or without
              notice to you. The Application relies on third-party technology
              and services (e.g. web hosting services). Any change to the
              services offered by these third-party providers may entirely
              disable, reduce, or adversely affect your use of or access to the
              Application and Services. No oral or written information or advice
              given by Last Minute Wellness, its agents, employees, or
              representatives will create a warranty or in any way increase the
              scope of the warranties in these Terms.
            </p>
            <p>
              To the extent any error results from Last Minute Wellness’
              reliance on information provided by or on behalf of you, or anyone
              that Last Minute Wellness reasonably believes to be associated
              with you, including appointment scheduling errors (each, a{" "}
              <strong>“Resulting Error”</strong>), then Last Minute Wellness may
              attempt to correct the Resulting Error, but makes no warranties or
              guarantees that it will be able to partially or fully correct the
              Resulting Error and will not be liable for any failure to
              partially or fully correct such Resulting Error. Nevertheless,
              Last Minute Wellness, may, at its sole discretion to receive a
              partial or full refund of all prepaid amounts.
            </p>
            <h5 className="font-semibold mt-2">LIABILITY</h5>
            <h5 className="font-semibold">Limitation of Liability</h5>
            <p>
              LAST MINUTE WELLNESS AND ITS AFFILIATES SHALL NOT BE LIABLE FOR
              INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, PUNITIVE OR
              CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS, LOST REVENUES, LOSS
              OF BUSINESS OPPORTUNITIES, LOST DATA, PERSONAL INJURY OR PROPERTY
              DAMAGE RELATED TO, IN CONNECTION WITH, OR OTHERWISE RESULTING FROM
              ANY USE OF THE SERVICES, EVEN IF LAST MINUTE WELLNESS HAS BEEN
              ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. LAST MINUTE WELLNESS
              SHALL NOT BE LIABLE FOR ANY DAMAGES, LIABILITY OR LOSSES ARISING
              OUT OF: (i) YOUR USE OF OR RELIANCE ON THE SERVICES OR YOUR
              INABILITY TO ACCESS OR USE THE SERVICES; OR (ii) ANY TRANSACTION
              OR RELATIONSHIP BETWEEN YOU AND ANY THIRD PARTY PROVIDER, EVEN IF
              LAST MINUTE WELLNESS HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH
              DAMAGES. LAST MINUTE WELLNESS SHALL NOT BE LIABLE FOR DELAY OR
              FAILURE IN PERFORMANCE RESULTING FROM CAUSES BEYOND LAST MINUTE
              WELLNESS’S REASONABLE CONTROL. IN NO EVENT SHALL LAST MINUTE
              WELLNESS’S TOTAL LIABILITY TO YOU IN CONNECTION WITH THE SERVICES
              FOR ALL DAMAGES, LOSSES AND CAUSES OF ACTION EXCEED THE GREATER OF
              YOUR PREPAID SUMS IN CONNECTION WITH THE PREPAID SUMS PAID BY YOU
              FOR THE SERVICES FOR WHICH THE APPLICABLE CLAIM AROSE OR ONE
              HUNDRED CANADIAN DOLLARS (CAD $100).
            </p>
            <p>
              THE SERVICES MAY BE USED BY YOU TO REQUEST AND SCHEDULE SERVICES
              WITH THIRD PARTY PROVIDERS, BUT YOU AGREE THAT LAST MINUTE
              WELLNESS HAS NO RESPONSIBILITY OR LIABILITY TO YOU RELATED TO ANY
              SERVICES PROVIDED TO YOU BY THIRD PARTY PROVIDERS OTHER THAN AS
              EXPRESSLY SET FORTH IN THESE TERMS.
            </p>
            <p>
              THE LIMITATIONS AND DISCLAIMER IN THIS SECTION DO NOT PURPORT TO
              LIMIT LIABILITY OR ALTER YOUR RIGHTS AS A CONSUMER UNDER
              APPLICABLE LAW.
            </p>
            <h5 className="font-semibold mt-2">INDEMNITY</h5>
            <p>
              You agree to indemnify and hold Last Minute Wellness and its
              affiliates and their officers, directors, employees and agents
              harmless from any and all claims, demands, losses, liabilities,
              and expenses (including reasonable attorneys’ fees) arising out of
              or in connection with: (i) your use of the Services or services or
              goods obtained through your use of the Services; (ii) your breach
              or violation of any of these Last Minute Wellness Terms; (iii)
              Last Minute Wellness’s use of your User Content; or (iv) your
              violation of the rights of any third party, including Third Party
              Providers (<strong>“Losses”</strong>).
            </p>
          </div>

          <div>
            <h1 className="font-semibold">6. GOVERNING LAW</h1>
            <p>
              These Last Minute Wellness Terms shall be exclusively governed by
              and construed in accordance with the laws of the province of
              Alberta, without regard to conflict of law principles.
            </p>
          </div>

          <div>
            <h1 className="font-semibold">7. DISPUTE RESOLUTION</h1>
            <p>
              IMPORTANT: PLEASE READ THE FOLLOWING ARBITRATION REQUIREMENT
              CAREFULLY. YOU WILL HAVE TO RESOLVE DISPUTES THROUGH ARBITRATION.
              YOU WILL NOT BE ELIGIBLE TO GET MONEY OR OTHER RELIEF THROUGH A
              COURT PROCEEDING.{" "}
            </p>
            <h5 className="font-semibold mt-2">ARBITRATION REQUIREMENT</h5>
            <p>
              You are free to get advice or representation from a lawyer about
              this arbitration requirement.
            </p>
            <p>
              Unless prohibited by law, all disputes arising out of or relating
              in any way to: i) these Last Minute Wellness Terms, ii) the
              Services, iii) your access to or use of the Applications, or iv)
              advertisements, promotions or oral or written statements related
              to the Applications or any other Last Minute Wellness branded
              product or Services will be finally and conclusively adjudicated
              and resolved by arbitration under the Arbitration Rules (
              <strong>“ADRIC Rules”</strong>) of the ADR Institute of Canada,
              Inc. (<strong>“ADRIC”</strong>), except as modified here. The
              arbitration will be in English. The arbitration will be held in
              the City of Calgary, however, that attendance of the parties may
              occur remotely by telephone or Internet.
            </p>
            <p>
              You will have to pay some fees to arbitrate, as described in the
              ADRIC Rules.
            </p>
            <p>
              However, before beginning the arbitration, the party with the
              claim will first try to informally negotiate with the other party,
              in good faith, a resolution of the dispute for not less than 30
              days but no more than 45 days unless extended by agreement. During
              the negotiation period, any otherwise applicable limitation period
              will be tolled (temporarily suspended).
            </p>
            <p>
              Where you allege claims of sexual assault or sexual harassment,
              you may choose to bring those specific claims in court instead of
              arbitration. Last Minute Wellness agrees to honour your choice of
              forum with respect to your individual sexual harassment or sexual
              assault claim but in doing so Last Minute Wellness does not waive
              the enforceability of any other part of this section 7.
            </p>
            <p>
              Nothing here prevents you from filing a claim with a government
              agency.
            </p>
            <p>
              This arbitration requirement survives: (i) the termination of this
              Agreement and (ii) the bankruptcy of any party. If any part of it
              is deemed invalid or unenforceable, the other parts remain in
              force.
            </p>
          </div>

          <div>
            <h1 className="font-semibold">8. OTHER PROVISIONS</h1>
            <h5 className="font-semibold mt-2">Claims of Copyright Infringement</h5>
            <p>
              Claims of copyright infringement should be sent to Last Minute
              Wellness at{" "}
              <a
                href="info@lastminutewellness.ca."
                className="text-blue-600 underline"
              >
                info@lastminutewellness.ca.
              </a>
              .
            </p>
            <h5 className="font-semibold mt-2">Notice</h5>
            <p>
              Last Minute Wellness may give notice by means of a general notice
              on the Services, electronic mail to your email address in your
              Account, or by written communication sent to your address as set
              forth in your Account. You may give notice to Last Minute Wellness
              by written communication to{" "}
              <a
                href="info@lastminutewellness.ca."
                className="text-blue-600 underline"
              >
                info@lastminutewellness.ca.
              </a>
              .
            </p>
            <h5 className="font-semibold mt-2">General</h5>
            <p>
              You may not assign or transfer these Last Minute Wellness Terms in
              whole or in part without Last Minute Wellness’s prior written
              approval. You give your approval to Last Minute Wellness for it to
              assign or transfer these Last Minute Wellness Terms in whole or in
              part, including to: (i) a subsidiary or affiliate; (ii) an
              acquirer of Last Minute Wellness’s equity, business or assets; or
              (iii) a successor by merger. No joint venture, partnership,
              employment or agency relationship exists between you, Last Minute
              Wellness or any Third Party Provider as a result of the contract
              between you and Last Minute Wellness or use of the Services.
            </p>
            <p>
              If any provision of these Last Minute Wellness Terms is held to be
              illegal, invalid or unenforceable, in whole or in part, under any
              law, such provision or part thereof shall to that extent be deemed
              not to form part of these Last Minute Wellness Terms but the
              legality, validity and enforceability of the other provisions in
              these Last Minute Wellness Terms shall not be affected. In that
              event, the parties shall replace the illegal, invalid or
              unenforceable provision or part thereof with a provision or part
              thereof that is legal, valid and enforceable and that has, to the
              greatest extent possible, a similar effect as the illegal, invalid
              or unenforceable provision or part thereof, given the contents and
              purpose of these Last Minute Wellness Terms. These Last Minute
              Wellness Terms, including any incorporated policies, constitute
              the entire agreement and understanding of the parties with respect
              to its subject matter and replaces and supersedes all prior or
              contemporaneous agreements or undertakings regarding such subject
              matter. Nothing in this clause limits your rights as a consumer
              under applicable law. In these Last Minute Wellness Terms, the
              words “including” and “include” mean “including, but not limited
              to”.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
